export default "__VITE_ASSET__D2tU553W__"